import { TransformItemsStructure } from './transformItemsStructure'

export const findParentId = (selectedId: string, items: TransformItemsStructure[]) => {
  return items.find((item) => item.subItems?.some((subItem) => subItem.id === selectedId))?.id
}
